import { CSSResultGroup, html, LitElement, nothing } from 'lit'
import { customElement } from 'lit/decorators.js'
import { consume } from '@lit/context'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'
import { rmaStickyBar } from './sticky-bar.style.js'
import { draftRmaContext, NotFetchedYet } from 'components/ordering/rma/components/context/rma-context.js'
import { RmaDraftDTO } from 'components/ordering/rma/api/dtos/rma-draft-dto.js'
import 'components/ordering/rma/components/rma/discard-button.js'

export const RMA_OVERVIEW_REQUESTED = 'csc-rma-overview-requested'

const translations = {
  openOverview: () => t('open_overview', { ns: 'csc-rma-sticky-bar', default: 'Show overview' }),
}

@customElement('csc-rma-sticky-bar')
export class CSCRmaStickyBar extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, rmaStickyBar]

  @consume({ context: draftRmaContext, subscribe: true })
  private draftRma: RmaDraftDTO | null | NotFetchedYet = new NotFetchedYet()

  private get lineCount(): number {
    return this.draftRma instanceof RmaDraftDTO ? this.draftRma.lines.length : 0
  }

  private requestOverview() {
    this.dispatchEvent(new CustomEvent(RMA_OVERVIEW_REQUESTED, { bubbles: true, composed: true }))
  }

  override render() {
    if (this.lineCount === 0) {
      return nothing
    }
    return html`
      <cse-sticky-bar data-test="overview-bar" position="bottom">
        <div class="rma-sticky-bar__actions">
          <csc-rma-discard-button></csc-rma-discard-button>
          <cse-button data-test="open-overview" variant="primary" @click=${() => this.requestOverview()}>
            ${translations.openOverview()}
            <cse-badge data-test="line-count" composition="floating" size="small">${this.lineCount}</cse-badge>
          </cse-button>
        </div>
      </cse-sticky-bar>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-rma-sticky-bar': CSCRmaStickyBar
  }
}
